import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "$styles/blog_post.css"

import { application } from "./controllers/application"
import HashOpenController from "./controllers/hash_open_controller"
import ExpandableGridController from "./controllers/expandable_grid_controller"
import WaitlistGateController from "./controllers/waitlist_gate_controller"
import ThemePickerController from "./controllers/theme_picker_controller"
import ClipboardController from "./controllers/clipboard_controller"

application.register("hash-open", HashOpenController)
application.register("expandable-grid", ExpandableGridController)
application.register("waitlist-gate", WaitlistGateController)
application.register("theme-picker", ThemePickerController)
application.register("clipboard", ClipboardController)

// Import component-attached assets from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

void components
